import type { PaymentSourcesOut } from 'openapi-client';

/**
 * Initial data the fw-unicorn payment-method-update embed puts in
 * `window.__INITIAL_DATA__`: the payment method currently on file, so the parent sees what
 * they are replacing, and where to send them once it has been replaced.
 *
 * The embed route serves HTML, so its response body is not in the OpenAPI spec; the payment
 * sources are the same shape as the generated `PaymentSourcesOut`.
 */
export interface PaymentMethodUpdateModel extends PaymentSourcesOut {
	/**
	 * Where the parent goes after the update — their profile on the parent platform, which is
	 * a different origin than this page. Same role as `BasketStatusOut.redirect_url` on
	 * checkout: a ready-to-use destination, not something the page derives.
	 */
	redirect_url?: string | null;
}

/** Fallback used when the host page did not provide initial data (e.g. local dev). */
export function normalizePaymentMethodUpdateModel(
	initialData: PaymentMethodUpdateModel | null | undefined,
): PaymentMethodUpdateModel {
	return {
		payment_sources: initialData?.payment_sources ?? [],
		redirect_url: initialData?.redirect_url ?? null,
	};
}
